// src/data/bibleMetadata.js
// This file stores the metadata (names, chapters) for all 66 books.

export const bibleMetadata = [
  // Old Testament
  { name_en: 'Genesis', name_te: 'ఆదికాండము', chapters: 50, testament: 'Old' },
  { name_en: 'Exodus', name_te: 'నిర్గమకాండము', chapters: 40, testament: 'Old' },
  { name_en: 'Leviticus', name_te: 'లేవీయకాండము', chapters: 27, testament: 'Old' },
  { name_en: 'Numbers', name_te: 'సంఖ్యాకాండము', chapters: 36, testament: 'Old' },
  { name_en: 'Deuteronomy', name_te: 'ద్వితీయోపదేశకాండము', chapters: 34, testament: 'Old' },
  { name_en: 'Joshua', name_te: 'యెహోషువ', chapters: 24, testament: 'Old' },
  { name_en: 'Judges', name_te: 'న్యాయాధిపతులు', chapters: 21, testament: 'Old' },
  { name_en: 'Ruth', name_te: 'రూతు', chapters: 4, testament: 'Old' },
  { name_en: '1 Samuel', name_te: '1 సమూయేలు', chapters: 31, testament: 'Old' },
  { name_en: '2 Samuel', name_te: '2 సమూయేలు', chapters: 24, testament: 'Old' },
  { name_en: '1 Kings', name_te: '1 రాజులు', chapters: 22, testament: 'Old' },
  { name_en: '2 Kings', name_te: '2 రాజులు', chapters: 25, testament: 'Old' },
  { name_en: '1 Chronicles', name_te: '1 దినవృత్తాంతములు', chapters: 29, testament: 'Old' },
  { name_en: '2 Chronicles', name_te: '2 దినవృత్తాంతములు', chapters: 36, testament: 'Old' },
  { name_en: 'Ezra', name_te: 'ఎజ్రా', chapters: 10, testament: 'Old' },
  { name_en: 'Nehemiah', name_te: 'నెహెమ్యా', chapters: 13, testament: 'Old' },
  { name_en: 'Esther', name_te: 'ఎస్తేరు', chapters: 10, testament: 'Old' },
  { name_en: 'Job', name_te: 'యోబు', chapters: 42, testament: 'Old' },
  { name_en: 'Psalms', name_te: 'కీర్తనలు', chapters: 150, testament: 'Old' },
  { name_en: 'Proverbs', name_te: 'సామెతలు', chapters: 31, testament: 'Old' },
  { name_en: 'Ecclesiastes', name_te: 'ప్రసంగి', chapters: 12, testament: 'Old' },
  { name_en: 'Song of Solomon', name_te: 'పరమగీతము', chapters: 8, testament: 'Old' },
  { name_en: 'Isaiah', name_te: 'యెషయా', chapters: 66, testament: 'Old' },
  { name_en: 'Jeremiah', name_te: 'యిర్మీయా', chapters: 52, testament: 'Old' },
  { name_en: 'Lamentations', name_te: 'విలాపవాక్యములు', chapters: 5, testament: 'Old' },
  { name_en: 'Ezekiel', name_te: 'యెహెజ్కేలు', chapters: 48, testament: 'Old' },
  { name_en: 'Daniel', name_te: 'దానియేలు', chapters: 12, testament: 'Old' },
  { name_en: 'Hosea', name_te: 'హోషేయ', chapters: 14, testament: 'Old' },
  { name_en: 'Joel', name_te: 'యోవేలు', chapters: 3, testament: 'Old' },
  { name_en: 'Amos', name_te: 'ఆమోసు', chapters: 9, testament: 'Old' },
  { name_en: 'Obadiah', name_te: 'ఓబద్యా', chapters: 1, testament: 'Old' },
  { name_en: 'Jonah', name_te: 'యోనా', chapters: 4, testament: 'Old' },
  { name_en: 'Micah', name_te: 'మీకా', chapters: 7, testament: 'Old' },
  { name_en: 'Nahum', name_te: 'నహూము', chapters: 3, testament: 'Old' },
  { name_en: 'Habakkuk', name_te: 'హబక్కూకు', chapters: 3, testament: 'Old' },
  { name_en: 'Zephaniah', name_te: 'జెఫన్యా', chapters: 3, testament: 'Old' },
  { name_en: 'Haggai', name_te: 'హగ్గయి', chapters: 2, testament: 'Old' },
  { name_en: 'Zechariah', name_te: 'జెకర్యా', chapters: 14, testament: 'Old' },
  { name_en: 'Malachi', name_te: 'మలాకీ', chapters: 4, testament: 'Old' },
  // New Testament
  { name_en: 'Matthew', name_te: 'మత్తయి సువార్త', chapters: 28, testament: 'New' },
  { name_en: 'Mark', name_te: 'మార్కు సువార్త', chapters: 16, testament: 'New' },
  { name_en: 'Luke', name_te: 'లూకా సువార్త', chapters: 24, testament: 'New' },
  { name_en: 'John', name_te: 'యోహాను సువార్త', chapters: 21, testament: 'New' },
  { name_en: 'Acts', name_te: 'అపొస్తలుల కార్యములు', chapters: 28, testament: 'New' },
  { name_en: 'Romans', name_te: 'రోమీయులకు', chapters: 16, testament: 'New' },
  { name_en: '1 Corinthians', name_te: '1 కొరింథీయులకు', chapters: 16, testament: 'New' },
  { name_en: '2 Corinthians', name_te: '2 కొరింథీయులకు', chapters: 13, testament: 'New' },
  { name_en: 'Galatians', name_te: 'గలతీయులకు', chapters: 6, testament: 'New' },
  { name_en: 'Ephesians', name_te: 'ఎఫెసీయులకు', chapters: 6, testament: 'New' },
  { name_en: 'Philippians', name_te: 'ఫిలిప్పీయులకు', chapters: 4, testament: 'New' },
  { name_en: 'Colossians', name_te: 'కొలొస్సయులకు', chapters: 4, testament: 'New' },
  { name_en: '1 Thessalonians', name_te: '1 థెస్సలొనీకయులకు', chapters: 5, testament: 'New' },
  { name_en: '2 Thessalonians', name_te: '2 థెస్సలొనీకయులకు', chapters: 3, testament: 'New' },
  { name_en: '1 Timothy', name_te: '1 తిమోతికి', chapters: 6, testament: 'New' },
  { name_en: '2 Timothy', name_te: '2 తిమోతికి', chapters: 4, testament: 'New' },
  { name_en: 'Titus', name_te: 'తీతుకు', chapters: 3, testament: 'New' },
  { name_en: 'Philemon', name_te: 'ఫిలేమోనుకు', chapters: 1, testament: 'New' },
  { name_en: 'Hebrews', name_te: 'హెబ్రీయులకు', chapters: 13, testament: 'New' },
  { name_en: 'James', name_te: 'యాకోబు', chapters: 5, testament: 'New' },
  { name_en: '1 Peter', name_te: '1 పేతురు', chapters: 5, testament: 'New' },
  { name_en: '2 Peter', name_te: '2 పేతురు', chapters: 3, testament: 'New' },
  { name_en: '1 John', name_te: '1 యోహాను', chapters: 5, testament: 'New' },
  { name_en: '2 John', name_te: '2 యోహాను', chapters: 1, testament: 'New' },
  { name_en: '3 John', name_te: '3 యోహాను', chapters: 1, testament: 'New' },
  { name_en: 'Jude', name_te: 'యూదా', chapters: 1, testament: 'New' },
  { name_en: 'Revelation', name_te: 'ప్రకటన గ్రంథము', chapters: 22, testament: 'New' },
];